import React from "react";
import { Card, CardProps, Box } from "@mui/material";
import { DtHeader } from "../header";

export type DtCardVariant = "flat" | "small" | "med";

interface DtCardProps extends CardProps {
  dtVariant?: DtCardVariant;
  header?: React.ReactNode; // Accepts string or JSX for header/title
  actions?: React.ReactNode; // New: actions for header right side
  children: React.ReactNode;
  contentContainerSx?: object; 
}

const shadowMap: Record<DtCardVariant, number> = {
  flat: 0,
  small: 2,
  med: 6,
};

const DtCard: React.FC<DtCardProps> = ({
  dtVariant = "flat",
  header,
  actions,
  children,
  sx,
  contentContainerSx,
  ...rest
}) => (
  <Card
    elevation={shadowMap[dtVariant]}
    sx={{
      borderRadius: 2,
      ...(sx || {}),
    }}
    {...rest}
  >
    {(header || actions) && (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2, py: 1 }}>
        <DtHeader>{header}</DtHeader>
        {actions && <Box>{actions}</Box>}
      </Box>
    )}
    <Box sx={{ px: 2, pb: 0 , ...contentContainerSx}}>
      {children}
    </Box>
  </Card>
);

export { DtCard };